import React, { ReactElement } from "react";
import GlobalCategoryList from "../../components/GlobalCategory";
import Layout from "../../components/layout";

const GlobalCategoryPage = (): ReactElement => {
  return (
    <Layout>
      <GlobalCategoryList />
    </Layout>
  );
};

export default GlobalCategoryPage;